import * as React from 'react'

export const IconMenu = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 344.339 344.339" xmlSpace="preserve" {...props}>
      <path d="M0 46.06H344.339V75.58H0z" />
      <path d="M0 156.506H344.339V186.026H0z" />
      <path d="M0 268.748H344.339V298.279H0z" />
    </svg>
  )
}
